<mat-tab-group dynamicHeight="false"  style="height:100%;border:1px solid white" preserveContent="true" #student_tabs>
    <!-- <mat-tab label="Profile" bodyClass="popuptab-body">
        <ng-template matTabContent>
            <div>
                <app-student-details studentId="studentId"></app-student-details>
            </div>
        </ng-template>
    </mat-tab> -->

    <mat-tab label="Student View" bodyClass="popuptab-body" labelClass="popuptab-label">
        <ng-template matTabContent >
            <app-student-in-apage #app_student_in_apage [accountReference]="accountReference" [studentId]="studentId"></app-student-in-apage>
        </ng-template>
    </mat-tab>
    
    <mat-tab label="AI Timeline" [disabled]="accountReference!='DEMO_MAT_1'" 
        bodyClass="popuptab-body"  labelClass="popuptab-label">
        <ng-template matTabContent>
            <app-student-time-line studentId="studentId"></app-student-time-line>
        </ng-template>
    </mat-tab>

</mat-tab-group>